import {createFeatureSelector, createSelector} from '@ngrx/store';
import {FeatureKeys} from '../app.reducer';
import {ScheduleRotationState} from './schedule-rotation.reducer';
import {Department, IAsyncData, IScheduleRotation, IWeek} from '@signal/asp-data-commons';
import * as fromAdapter from './schedule-rotation.adapter';

export const selectScheduleRotationFeature = createFeatureSelector<ScheduleRotationState>(FeatureKeys.SCHEDULE_ROTATION);

export const selectScheduleRotation = createSelector(
  selectScheduleRotationFeature,
  (state: ScheduleRotationState, props: { department: Department, id: string }) => state[props.department?.toLowerCase()]
);

export const selectScheduleRotationData = createSelector(
  selectScheduleRotation,
  (scheduleRotation: IAsyncData<{ [key: string]: IScheduleRotation }>, props: { department: Department, id: string }) => scheduleRotation.data
);

export const selectScheduleRotations = createSelector(
  selectScheduleRotation,
  (scheduleRotation: IAsyncData<{ [key: string]: IScheduleRotation }>, props: { department: Department, id: string }) => Object.values(scheduleRotation?.data ||  {})
);

export const selectScheduleRotationsByStartDate = createSelector(
  selectScheduleRotations,
  (scheduleRotations: IScheduleRotation[], props: { department: Department, id: string }) => fromAdapter.orderScheduleRotationsByDate(scheduleRotations)
);

export const selectScheduleRotationDataById = createSelector(
  selectScheduleRotation,
  (scheduleRotation: IAsyncData<{ [key: string]: IScheduleRotation }>, props: { department: Department, id: string }) => fromAdapter.orderShiftsByTime(scheduleRotation.data[props.id])
);

export const selectScheduleRotationShiftsSortedId = createSelector(
  selectScheduleRotation,
  (scheduleRotation: IAsyncData<{ [key: string]: IScheduleRotation }>, props: { department: Department, id: string }) => fromAdapter.getShiftIdsSorted(scheduleRotation.data[props.id])
);

export const selectScheduleRotationLoading = createSelector(
  selectScheduleRotation,
  (scheduleRotation: IAsyncData<{ [key: string]: IScheduleRotation }>, props: { department: Department }) => scheduleRotation.loading
);

export const selectScheduleRotationLoaded = createSelector(
  selectScheduleRotation,
  (scheduleRotation: IAsyncData<{ [key: string]: IScheduleRotation }>, props: { department: Department, id: string }) => scheduleRotation.loaded
);

export const selectScheduleRotationStartDate = createSelector(
  selectScheduleRotationDataById,
  (scheduleRotation: IScheduleRotation, props: { department: Department, id: string }) => scheduleRotation.startDate
);

export const selectScheduleRotationWeeklyDetails = createSelector(
  selectScheduleRotationDataById,
  (scheduleRotation: IScheduleRotation, props: { department: Department, id: string }) => scheduleRotation.rotation
);

export const selectScheduleRotationDailyDetails = createSelector(
  selectScheduleRotationWeeklyDetails,
  (scheduleRotation: IWeek[], props: { department: Department, id: string, index: number, day: string }) => scheduleRotation[props.index][props.day]
);

export const selectActiveScheduleRotationLabels = createSelector(
  selectScheduleRotations,
  (scheduleRotation: IScheduleRotation[], props: { department: Department, id: string }) => fromAdapter.getActiveScheduleRotationLabels(scheduleRotation)
);

export const selectAllOtherStartDates = createSelector(
  selectScheduleRotations,
  (scheduleRotation: IScheduleRotation[], props: { department: Department, id: string }) => fromAdapter.getAllOtherStartDates(scheduleRotation, props.id)
);
